import { render, staticRenderFns } from "./XFormPassword.vue?vue&type=template&id=0e46a4ea&"
import script from "./XFormPassword.vue?vue&type=script&lang=js&"
export * from "./XFormPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports